import React, { FC } from "react";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { DashboardContextProvider } from "../../../contexts/dashboard/DashboardContextProvider";
import { useLocale } from "../../../contexts/localeContext";

const Dashboard: FC = () => {
    const { translate } = useLocale();

    const breadcrumb = [
        {
            value: "/access-control/monitoring",
            displayName: translate.byKey(TranslationKeys.monitoring),
        },
        {
            value: "/access-control/monitoring/dashboard",
            displayName: translate.byKey(TranslationKeys.dashboard),
        },
    ];

    return <DashboardContextProvider
            key={"dashboard"}
            breadcrumb={breadcrumb} />
}
export default Dashboard;